/**
 * ConfirmPopup component.
 *
 * This component is used to confirm that the user does not want to use Edit-Options.
 * It is used to display a popup with a title, icon, and buttons.
 */

import React from "react";
import { Popup } from "devextreme-react/popup";
import { Button } from "devextreme-react/button";

/**
 * Props:
 * - isVisible: Whether the popup is visible.
 * - onYes: The function to call when the yes button is clicked.
 * - onNo: The function to call when the no button is clicked.
 * - message: Optional custom message to display. If not provided, uses default message.
 */
const ConfirmPopup = ({ isVisible, onYes, onNo, message }) => {
  const defaultMessage = "Are you sure you don't want to use Edit-Options?";

  const renderTitle = () => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <i
          className={`dx-icon dx-icon-info`}
          style={{ fontSize: "24px", marginRight: "10px" }}
        ></i>

        <h1 style={{ fontSize: "1.2rem", fontWeight: "600", marginTop: "8px" }}>
          {"Edit verification"}
        </h1>
      </div>
    );
  };

  return (
    <Popup
      visible={isVisible}
      titleRender={renderTitle}
      hideOnOutsideClick={false}
      showTitle={true}
      onYes={onYes}
      onNo={onNo}
      resizeEnabled={false}
      dragEnabled={true}
      width={"auto"}
      height={"auto"}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "70%",
        }}
      >
        <span style={{ fontSize: "1.1rem", textAlign: "center" }}>
          {message || defaultMessage}
        </span>

        <div
          className="popup-footer"
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <Button text="Yes" onClick={onYes} style={{ width: "100px" }} />
          <Button text="No" onClick={onNo} style={{ width: "100px" }} />
        </div>
      </div>
    </Popup>
  );
};

export default ConfirmPopup;
